import { ProgramNames } from '../../models/programs/Programs'

export const PROGRAM_SESSION_RESCHEDULE_MAP = {
  [ProgramNames.DIRECT_ACCESS_MEDS]: true,
  [ProgramNames.MedicationManagement]: false,
  [ProgramNames.SELF_CARE_APPS]: false,
  [ProgramNames.DIRECT_ACCESS_THERAPY]: true,
  [ProgramNames.BlendedCareTherapy]: true,
  [ProgramNames.Coaching]: true,
  [ProgramNames.SingleSessionCoaching]: true,
  [ProgramNames.AlcoholUseDisorderTherapy]: true,
  [ProgramNames.ICASTherapy]: false,
  [ProgramNames.DirectAccessIndividualTherapy]: true,
  [ProgramNames.DirectAccessCouplesTherapy]: true,
  [ProgramNames.DirectAccessFamilyTherapy]: true,
  [ProgramNames.DirectAccessIndividualAdolescentTherapy]: true,
  [ProgramNames.DirectAccessIndividualChildTherapy]: true,
}

export enum CANCELATION_OPTIONS {
  'needMoreTime' = 'needMoreTime',
  'lookingOtherCareOptions' = 'lookingOtherCareOptions',
  'readyToGraduate' = 'readyToGraduate',
  'emergency' = 'emergency',
  'notFeelingWell' = 'notFeelingWell',
  'schedulingConflict' = 'schedulingConflict',
  'other' = 'other',
}

export const INITIAL_DAYS_OF_AVAILABILITY_SHOWN = 7
